import { render, staticRenderFns } from "./ShippingAddFormHeader.vue?vue&type=template&id=fbc1352a"
import script from "./ShippingAddFormHeader.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports